<!-- <mat-horizontal-stepper [linear]="true" labelPosition="bottom" #stepper>
	<mat-step>
		<ng-template matStepLabel>Fill out your name</ng-template>
		<mat-form-field appearance="fill">
		  <mat-label>Name</mat-label>
		  <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
		</mat-form-field>
		<div>
		  <button mat-button matStepperNext>Next</button>
		</div>
	</mat-step>
	<mat-step [stepControl]="secondFormGroup" label="Fill out your address">
		<mat-form-field appearance="fill">
			<mat-label>Address</mat-label>
			<input matInput formControlName="secondCtrl" placeholder="Ex. 1 Main St, New York, NY"
				   required>
		  </mat-form-field>
		  <div>
			<button mat-button matStepperPrevious>Back</button>
			<button mat-button matStepperNext>Next</button>
		  </div>
	</mat-step>
	<mat-step>
	  <ng-template matStepLabel>Done</ng-template>
	  <p>You are now done.</p>
	  <div>
		<button mat-button matStepperPrevious>Back</button>
		<button mat-button (click)="stepper.reset()">Reset</button>
	  </div>
	</mat-step>
  </mat-horizontal-stepper> -->

<!-- <mat-stepper [linear]="isLinear" #stepper>
	<mat-step [stepControl]="firstFormGroup">
	  <form [formGroup]="firstFormGroup">
		<ng-template matStepLabel>Select Partner</ng-template>
		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card" *ngFor="let item of distis">
				<div class="card-body" (click)="onDisti(item)">{{item.name}}</div>
			</div>
		</div>
		<div>
		  <button mat-button matStepperNext>Next</button>
		</div>
	  </form>
	</mat-step>
	<mat-step [stepControl]="secondFormGroup" label="Fill out your address">
	  <form [formGroup]="secondFormGroup">
		<p>Please select a client</p>
		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card" *ngFor="let item of clients">
				<div class="card-body" (click)="onClient(item)">{{item.company_name}}</div>
			</div>
		</div>
		<div>
		  <button mat-button matStepperPrevious>Back</button>
		  <button mat-button matStepperNext>Next</button>
		</div>
	  </form>
	</mat-step>
	<mat-step [stepControl]="secondFormGroup" label="Fill out your address">
		<form [formGroup]="secondFormGroup">
			<p>Please select a client</p>
			<div class="row justify-content-center mb-4">
				<div class="card pointer select-card" *ngFor="let item of campuses">
					<div class="card-body" (click)="onCampus(item)">{{item.name}}</div>
				</div>
			</div>
		  <div>
			<button mat-button matStepperPrevious>Back</button>
			<button mat-button matStepperNext>Next</button>
		  </div>
		</form>
	  </mat-step>

	  <ng-template matStepLabel>Done</ng-template>
	  <p>You are now done.</p>
	  <div>
		<button mat-button matStepperPrevious>Back</button>
		<button mat-button (click)="stepper.reset()">Reset</button>
	  </div>
	</mat-step>
  </mat-stepper> -->




<div *ngIf="distis && !selectedDisti">

	<div class="row">
		<h6 class="text-dark float-right">Select a Partner</h6>
		<mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input
				matInput
				placeholder="search..."
				[value]="distiSearchTerm"
				#distiSearchInput
				(input)="onDistiSearch(distiSearchInput.value)">
		</mat-form-field>
	</div>
	<div mat-dialog-content>

		<p *ngIf="noDisti" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4 mt-3 mb-3">
			<div class="card pointer select-card mt-3 ml-3 mr-3" *ngFor="let item of filteredDistis">
				<div class="card-body" (click)="onDisti(item)">{{item.name}}</div>
			</div>
		</div>
		<p *ngIf="distis && distis.length && !filteredDistis.length" class="mx-auto text-center mt-3">No matching records found</p>
	</div>
	<div mat-dialog-actions class="justify-content-end mt-5">
		<button class="mr-3" type="button" mat-raised-button
				color="warn" [mat-dialog-close]="">
				Cancel
		</button>
	</div>

</div>

<div *ngIf="selectedDisti && selectedDisti.disti_id != null && markets && !selectedMarket && !selectedClient">
	<div class="row">
		<h6 class="text-dark float-right">Select a Market</h6>
		<mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input
				matInput
				placeholder="search..."
				[value]="marketSearchTerm"
				#marketSearchInput
				(input)="onMarketSearch(marketSearchInput.value)">
		</mat-form-field>
	</div>
	<div mat-dialog-content>

		<p *ngIf="noMarket" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card  mt-3 ml-3 mr-3" *ngFor="let item of filteredMarkets">
				<div class="card-body" (click)="onMarket(item)">{{item.market_name}}</div>
			</div>
		</div>
		<p *ngIf="markets && markets.length && !filteredMarkets.length" class="mx-auto text-center mt-3">No matching records found</p>
	</div>
  <div mat-dialog-actions>
	<button *ngIf="data.bckBtn" type="button" class="float-left" (click)="onBack('disti')" mat-raised-button>
		back
	</button>
	<button type="button" class="ml-auto mr-3" mat-raised-button
			color="warn" [mat-dialog-close]="">
			close
	</button>
  </div>

</div>

<div *ngIf="(selectedDisti || selectedMarket) && (selectedMarket || !markets) && clients && !selectedClient">
	<div class="row">
		<h6 class="text-dark float-right">Select a Client</h6>
		<mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input
				matInput
				placeholder="search..."
				[value]="clientSearchTerm"
				#clientSearchInput
				(input)="onClientSearch(clientSearchInput.value)">
		</mat-form-field>
	</div>
	<div mat-dialog-content>

		<p *ngIf="noClient" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card  mt-3 ml-3 mr-3" *ngFor="let item of filteredClients">
				<div class="card-body" (click)="onClient(item)">{{item.company_name}}</div>
			</div>
		</div>
		<p *ngIf="clients && clients.length && !filteredClients.length" class="mx-auto text-center mt-3">No matching records found</p>
	</div>
  <div mat-dialog-actions>
	<button *ngIf="data.bckBtn && selectedDisti" type="button" class="float-left" (click)="onBack(selectedMarket ? 'market' : 'disti')" mat-raised-button>
		back
	</button>
	<button *ngIf="data.bckBtn && selectedMarket && !selectedDisti" type="button" class="float-left" (click)="onBack('market')" mat-raised-button>
		back
	</button>
	<button type="button" class="ml-auto mr-3" mat-raised-button
				color="warn" [mat-dialog-close]="">
				close
	</button>
  </div>

</div>

<div *ngIf="selectedClient && campuses">
	<div class="row">
		<h6 class="text-dark float-right">Select a Campus</h6>
		<mat-form-field class="col-xl-4 col-md-6 ml-auto pt-0" style="margin-top: -15px">
			<input
				matInput
				placeholder="search..."
				[value]="campusSearchTerm"
				#campusSearchInput
				(input)="onCampusSearch(campusSearchInput.value)">
		</mat-form-field>
	</div>
	<div mat-dialog-content>

		<p *ngIf="noCampus" class="mx-auto text-center mt-3">No records found</p>

		<div class="row justify-content-center mb-4">
			<div class="card pointer select-card  mt-3 ml-3 mr-3" *ngFor="let item of filteredCampuses">
				<div class="card-body" (click)="onCampus(item)">{{item.name}}</div>
			</div>
		</div>
		<p *ngIf="campuses && campuses.length && !filteredCampuses.length" class="mx-auto text-center mt-3">No matching records found</p>
	</div>
  <div mat-dialog-actions>
	<button *ngIf="data.bckBtn" type="button" class="float-left"  (click)="onBack('client')" mat-raised-button>
		back
	</button>
	<button type="button" class="ml-auto mr-3" mat-raised-button
				color="warn" [mat-dialog-close]="">
				close
			</button>
  </div>

</div>

